import { h } from "vue";
import { RouterLink } from "vue-router";

import { EMPLOYEE_ROUTE_NAMES } from "@/shared";

const EMPLOYEE_STATUS_TITLE = {
    OPENED: "открыл",
    CLOSED: "закрыл",
};
const RENT_STATUS_TYPE = {
    STARTED: "success",
    FINISHED: "warning",
    OVERDUE: "error",
    CANCELED: "attention",
    RENT_CLOSED: "neutral",
    ENDING_SOON: "attention",
};
const RENT_STATUS_ICON = {
    STARTED: "info",
    FINISHED: "info",
    OVERDUE: "error",
    CANCELED: "error",
    RENT_CLOSED: "cross",
    ENDING_SOON: "attention",
};
const RENT_STATUS_TITLE = {
    STARTED: "началась",
    FINISHED: "закончилась",
    OVERDUE: "просрочена",
    CANCELED: "отменена",
    RENT_CLOSED: "закрыта",
    ENDING_SOON: "скоро заканчивается",
};

const formatNotifyEmployee = (notify, id) => {
    return {
        id,
        type: "info",
        icon: "user",
        title: h("p", null, [
            "Сотрудник ",
            h(
                RouterLink,
                {
                    to: {
                        name: EMPLOYEE_ROUTE_NAMES.PROFILE,
                        params: { employeeId: notify.humanId },
                    },
                },
                notify.fio
            ),
            ` ${EMPLOYEE_STATUS_TITLE[notify.status]} смену на пункте ${
                notify.point
            }`,
        ]),
    };
};

const formatNotifyRent = (notify, id) => {
    if (notify.rentId == null || notify.rentNumber == null) {
        return null;
    }

    const type = RENT_STATUS_TYPE[notify.status] ?? "info";
    const icon = RENT_STATUS_ICON[notify.status] ?? "info";
    const titleText = RENT_STATUS_TITLE[notify.status] ?? "обновлена";

    return {
        id,
        type,
        icon,
        // Раздел аренд в Remboard отключён — показываем номер без ссылки
        title: h("p", null, `Заявка №${notify.rentNumber} ${titleText}`),
    };
};

const formatNotifyTariff = (notify, id) => {
    const days = notify.daysLeft ?? 0;
    const title = notify.tariffTitle ? ` «${notify.tariffTitle}»` : "";
    const lead = days
        ? `Тариф${title} заканчивается через ${days} дн.`
        : `Тариф${title} заканчивается`;
    const advice = notify.autoPayment
        ? "Включено автопродление — убедитесь, что на карте достаточно средств."
        : "Не забудьте оплатить. Рекомендуем включить автопродление.";

    return {
        id,
        type: notify.autoPayment ? "info" : "attention",
        icon: "info",
        title: h("p", null, `${lead} ${advice}`),
    };
};

// Смена статуса заказа мастерской: номер заказа и новый статус.
const formatNotifyRepair = (notify, id) => {
    if (notify.rentNumber == null) {
        return null;
    }

    return {
        id,
        type: "info",
        icon: "info",
        title: h(
            "p",
            null,
            `Заказ №${notify.rentNumber}: ${
                notify.repairState ?? "статус изменён"
            }`
        ),
    };
};

export const handlersByNotifyStatus = {
    OPENED: formatNotifyEmployee,
    CLOSED: formatNotifyEmployee,
    REPAIR_STATUS: formatNotifyRepair,
    STARTED: formatNotifyRent,
    FINISHED: formatNotifyRent,
    OVERDUE: formatNotifyRent,
    CANCELED: formatNotifyRent,
    RENT_CLOSED: formatNotifyRent,
    ENDING_SOON: formatNotifyRent,
    TARIFF_EXPIRING: formatNotifyTariff,
};

export const normalizeNotifications = (notifications) => {
    return notifications.reduce((notificationsList, notify) => {
        const handler = handlersByNotifyStatus[notify.data?.status];

        if (!handler) return notificationsList;

        const item = handler(notify.data, notify.id);

        if (!item) return notificationsList;

        // только валидная Date; иначе оставляем дефолт пропа (date-fns бросает на строке/undefined)
        if (notify.createdAt instanceof Date) {
            item.date = notify.createdAt;
        }

        notificationsList.push(item);

        return notificationsList;
    }, []);
};
